import UPTab from './UPTab';

export default UPTab;
